export const CRIMINAL_RECORD_VALIDATION = {
  MIN_DURATION_MONTHS: 1,
  MAX_DURATION_MONTHS: 100,
  DEFAULT_DURATION_MONTHS: 6,
  MIN_LOOKBACK_YEARS: 1,
  MAX_LOOKBACK_YEARS: 20,
  DEFAULT_LOOKBACK_YEARS: 5,
  SEVEN_YEAR_LOOKBACK_YEARS: 7,
} as const;

export const CCRC_LEVEL = {
  BASIC: "BASIC",
  ENHANCED: "ENHANCED",
} as const;

export const AUSTRALIAN_CRIMINAL_OPTION = {
  AFP: "AFP",
  STANDARD_NCCHC: "STANDARD_NCCHC",
  VOLUNTEER_NCCHC: "VOLUNTEER_NCCHC",
} as const;

export type AustralianCriminalOption =
  (typeof AUSTRALIAN_CRIMINAL_OPTION)[keyof typeof AUSTRALIAN_CRIMINAL_OPTION];

export const US_CRIMINAL_PREFERENCE = {
  NONE: "NONE",
  TIER_1: "TIER_1",
  TIER_2: "TIER_2",
  TIER_3: "TIER_3",
  CUSTOM: "CUSTOM",
} as const;
